import { useSelector } from 'react-redux';

function useSSO() {
  const sso = useSelector((state) => state.sso.toJS());
  return sso;
}

export default useSSO;
